export default "ALTER TABLE `provider` DROP COLUMN `is_default`;\n"